const items = ["Votre maison", "Votre projet", "Votre avenir", "Votre sérénité"];

export default function Marquee() {
  const content = [...items, ...items, ...items];
  return (
    <div className="border-y border-border py-6 overflow-hidden" data-testid="marquee-section">
      <div className="marquee-track flex whitespace-nowrap w-max">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {content.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-sub font-bold uppercase text-2xl sm:text-3xl tracking-[0.15em] text-ink/80 px-6">
                  {item}
                </span>
                <span className="w-2 h-2 rounded-full bg-terra" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
